
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favourites",
      function () {
        return require("private-next-pages/favourites/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/favourites"])
      });
    }
  